export function removeDuplicatesById(objects) {
  const idMap = new Map() // Use a Map to track unique IDs
  const uniqueObjects = []

  for (const obj of objects) {
    if (!idMap.has(obj.id)) {
      idMap.set(obj.id, true)
      uniqueObjects.push(obj)
    }
  }

  return uniqueObjects
}
